import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// Public (no-login) property-owner onboarding. No `meta.requiresAuth`, so the
// global guard lets anonymous visitors through — a property owner has no
// Sliceal account in this flow, and the emailed link is the only credential.
//
// Mounted under WizardLayout (full-screen, no app chrome) like the seller's twin
// below — the auth gate is per route, and this one deliberately has none.
//
// The path is not free to change: admin-service builds the invite URL as
// `${SELLER_WEB_BASE_URL}/owners/onboarding/<token>` and mails it. A rename here
// breaks every link already in an owner's inbox.
export const ownerOnboardingRoutes: RouteRecordRaw[] = [
  {
    path: routes.PUBLIC_OWNER_ONBOARDING,
    name: 'PUBLIC_OWNER_ONBOARDING',
    component: () => import('./OwnerOnboardingPage.vue'),
    meta: { title: 'Complete your owner details' },
  },
]

// The signed-in seller completing their own owner onboarding for one request.
// Behind the auth guard — the seller's JWT is what earns the session here, in
// place of the emailed token — but full-screen under WizardLayout, without the
// app sidebar or top bar: a guided flow like the listing wizard, with its own
// header's "Finish later" back to the request as the way out.
export const sellerOwnerOnboardingRoutes: RouteRecordRaw[] = [
  {
    path: routes.LISTING_OWNER_ONBOARDING,
    name: 'LISTING_OWNER_ONBOARDING',
    component: () => import('./SellerOwnerOnboardingPage.vue'),
    meta: {
      requiresAuth: true,
      title: 'Your owner details',
      subtitle: 'Complete your verification and payout details for this request.',
    },
  },
]
